import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogSiNoData, DialogSiNoComponent } from '../app/dialog-si-no/dialog-si-no.component';
import { Node } from './../model/Node';
import { DialogCrearDirectorioComponent } from '../app/admin/dialog-crear-directorio/dialog-crear-directorio.component';
import { DialogCrearFileDirectorioSelectorComponent, DialogCrearFileDirectorioSelectorComponentData } from '../app/admin/dialog-crear-file-directorio-selector/dialog-crear-file-directorio-selector.component';
import { DialogCrearFileComponent } from '../app/admin/dialog-crear-file/dialog-crear-file.component';

export interface NodeOperationResult {
  node: Node;
  addedNode: Node | undefined;
  type: string;
}
@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) { }

  confirm(data: Partial<DialogSiNoData> = {}): Observable<boolean> {
    const dialogData: DialogSiNoData = {
      title: data.title || 'title',
      message: data.message || 'message',
      confirmText: data.confirmText || 'confirmText',
      cancelText: data.cancelText || 'cancelText'
    };

    const dialogRef = this.dialog.open(DialogSiNoComponent, {
      data: dialogData,
      width: '400px'
    });

    return dialogRef.afterClosed();
  }

  agregarDirectorio(node: Node): Observable<NodeOperationResult> {
    const dialogData: DialogCrearFileDirectorioSelectorComponentData = {
      node: node
    }
    const dialogRef = this.dialog.open(DialogCrearDirectorioComponent, {
      data: dialogData,
      width: '400px'
    });

    return dialogRef.afterClosed();
  }

  agregarFile(node: Node): Observable<NodeOperationResult> {
    const dialogData: DialogCrearFileDirectorioSelectorComponentData = {
      node: node
    }
    const dialogRef = this.dialog.open(DialogCrearFileComponent, {
      data: dialogData,
      width: '400px'
    });

    return dialogRef.afterClosed();
  }

  /**
   * Crea el dialogo para selecionar creacion de archivo o directorio.
   * 
   * @param node el nodo de trabajo (el que seleccionamos la accion)
   * @returns el tipo de operacion para que lo pueda manejar el consumer? (files.component.ts)
   */
  agregarFileODirectorioSelector(node: Node): Observable<NodeOperationResult> {
    const dialogData: DialogCrearFileDirectorioSelectorComponentData = {
      node: node
    }

    const dialogRef = this.dialog.open(DialogCrearFileDirectorioSelectorComponent, {
      data: dialogData,
      width: '400px'
    });

    return dialogRef.afterClosed();
  }
}